export const situations = [
  {
    question: 'How can I evaluate whether a skeletal discrepancy is developing?',
    answer:
      'You recognize changes in facial or dental relationships but want a clearer framework for interpreting them.',
  },
  {
    question: 'Which growth indicators should I consider?',
    answer:
      'Chronological age alone doesn’t explain skeletal maturation, and interpreting developmental indicators requires context.',
  },
  {
    question: 'How do I organize my diagnostic findings?',
    answer:
      'Facial examination, dental relationships, imaging, and growth observations can feel disconnected without a structured assessment process.',
  },
  {
    question: 'When should orthopedic treatment be considered?',
    answer:
      'You want to understand the factors that influence treatment timing, observation, and specialist referral.',
  },
  {
    question: 'Which orthopedic appliance principles should I understand?',
    answer: 'You need a stronger conceptual foundation before comparing treatment approaches.',
  },
  {
    question: 'How can I document developmental changes consistently?',
    answer:
      'You want a repeatable framework for recording and reviewing growth-related clinical observations.',
  },
];
